// extracted by mini-css-extract-plugin
export default {"base":"order-history_base__OMb98","order":"order-history_order__+7pkU"};